import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Container from "./Container.jsx";
import {cancellation_policy} from "../datasource/schema";

class CancellationPolicyContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("cancellation_policy");
    }


    getBackLink = () => this.datasource.routes().home;

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Правила политики отмены"}
                        columns={{
                            id: "Id",
                            name: "Наименование",
                            active: "Активен",
                            order: "Порядок",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        updateParticularItem={this.updateParticularItem}
                        defaultSortfield="order"
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новое правило политики"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        interfaceTypes={this.state.interfaces}
                        thisCancellationPolicy={true}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактировать правило политики"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relationsDataSource={relationsDataSource} //
                        relations={relations}
                        interfaceTypes={this.state.interfaces}
                        thisCancellationPolicy={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default CancellationPolicyContainer;

